<template>
  <div class="draw-toolbar" v-if="visible">
    <div class="draw-toolbar__panel">
      <div class="draw-toolbar__row">
        <span class="draw-toolbar__info">点击地图添加点，已添加 {{ pointCount }} 个点</span>
        <span class="draw-toolbar__divider"></span>
        <span class="draw-toolbar__colors-label">颜色</span>
        <div
          v-for="option in colorOptions"
          :key="option.key"
          class="color-dot"
          :class="{ 'color-dot--active': drawColorKey === option.key }"
          :style="{ backgroundColor: option.hex }"
          @click="$bus.$emit('drawToolbarColorChange', option.key)"
        ></div>
      </div>
      <div class="draw-toolbar__row draw-toolbar__actions">
        <a-button
          size="small"
          :disabled="pointCount === 0"
          @click="$bus.$emit('drawToolbarUndo')"
        >
          <a-icon type="undo" /> 撤销
        </a-button>
        <a-button
          size="small"
          type="primary"
          :disabled="pointCount < 3"
          @click="$bus.$emit('drawToolbarFinish')"
        >
          <a-icon type="check" /> 完成
        </a-button>
        <a-button
          size="small"
          @click="$bus.$emit('drawToolbarCancel')"
        >
          <a-icon type="close" /> 取消
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { POLYGON_DEFAULT_COLOR_KEY, getPolygonColorOptions } from '@/utils/polygon-utils';

export default {
  props: {
    visible: Boolean,
    pointCount: {
      type: Number,
      default: 0,
    },
    drawColorKey: {
      type: String,
      default: POLYGON_DEFAULT_COLOR_KEY,
    },
  },
  data() {
    return {
      colorOptions: getPolygonColorOptions(),
    };
  },
};
</script>

<style scoped>
.draw-toolbar {
  position: absolute;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 500;
}

.draw-toolbar__panel {
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 10px 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.draw-toolbar__row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.draw-toolbar__actions {
  justify-content: center;
}

.draw-toolbar__info {
  font-size: 12px;
  color: #999999;
  white-space: nowrap;
}

.draw-toolbar__divider {
  width: 1px;
  height: 14px;
  background-color: #e8e8e8;
}

.draw-toolbar__colors-label {
  font-size: 12px;
  color: #666666;
}

.color-dot {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  cursor: pointer;
  border: 2px solid transparent;
  transition: border-color 0.2s;
}

.color-dot:hover {
  opacity: 0.85;
}

.color-dot--active {
  border-color: #1890ff;
}
</style>
